module.exports = __webpack_public_path__ + "img/information.120994b0.png";